import { crmEnv } from '@crm/shared/config/env'

if (!crmEnv.apiBaseUrl) {
  throw new Error('CRM API base URL is not defined')
}

export const API_BASE_URL = crmEnv.apiBaseUrl.endsWith('/')
  ? crmEnv.apiBaseUrl
  : `${crmEnv.apiBaseUrl}/`
